import { SpinResponse } from '@cgs/data-access';
import {
  FAST_SPINS_COMPONENT,
  FastSpinsComponent,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
} from '@cgs/machines';
import {
  TRIFECTA_SDK_ADAPTER_TOKEN,
  TrifectaSDKAdapter,
  TrifectaSDKTurboSpinMode,
} from '@cgs/provider-trifecta';
import { Container } from '@cgs/wge';

export const REGULAR_SPIN_DELAY_FACTOR = 1;
export const MEDIUM_SPIN_DELAY_FACTOR = 0.5;
export const FAST_SPIN_DELAY_FACTOR = 0;

const SPIN_DELAY_FACTOR_BY_TURBO_MODE = new Map<TrifectaSDKTurboSpinMode, number>([
  [TrifectaSDKTurboSpinMode.x1, REGULAR_SPIN_DELAY_FACTOR],
  [TrifectaSDKTurboSpinMode.x2, MEDIUM_SPIN_DELAY_FACTOR],
  [TrifectaSDKTurboSpinMode.x4, FAST_SPIN_DELAY_FACTOR],
]);

/**
 * Reel speed always comes from game-config.json (spinSpeed); turbo modes only
 * scale the inter-reel start/stop delays: x1 keeps them, x2 halves them,
 * x4 skips them entirely.
 */
export class CorsicaSpinDelayFactorProvider {
  private readonly trifectaSDKAdapter: TrifectaSDKAdapter | null;
  private readonly fastSpinsComponent: FastSpinsComponent;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    this.trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN, {
      optional: true,
    });
    this.fastSpinsComponent = container.resolve<FastSpinsComponent>(FAST_SPINS_COMPONENT);
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
  }

  public get spinDelayFactor(): number {
    if (!this.trifectaSDKAdapter) {
      return this.fastSpinsComponent.isFastSpinsActive
        ? FAST_SPIN_DELAY_FACTOR
        : REGULAR_SPIN_DELAY_FACTOR;
    }

    if (this.gameStateMachine.curResponse.isFreeSpins) {
      return REGULAR_SPIN_DELAY_FACTOR;
    }

    return (
      SPIN_DELAY_FACTOR_BY_TURBO_MODE.get(this.trifectaSDKAdapter.turboSpinMode) ??
      REGULAR_SPIN_DELAY_FACTOR
    );
  }
}
